<template>
  <div class="card-form">
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @reject="reject"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>
        <div class="drop">
          <el-dropdown
            v-if="allow('I')"
            size="small"
            split-button
            @click="$refs.orderImport.orderImport()"
            @command="importTemplate"
            class="ml-2"
          >
            <b-icon icon="cloud-upload" />
            {{ $l('btn_orderImport') || '订单导入' }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                {{ $l('dropdown_template') || '下载 京东备货订单模板' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </PageHeader>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <RejectedForm
      :visible.sync="rejectedFormOpts.visible"
      :hxPreOrderCode="rejectedFormOpts.hxPreOrderCode"
      @reload="reload"
    />

    <OrderImport ref="orderImport" @reload="reload" />
    <ChooseImportTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-preOrder' }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import RejectedForm from '../rejected-form'
import OrderImport from '../order-import'
import BaseTable from '@/mixins/base-table'
import ChooseImportTemplate from '@/views/ecom/components/choose-import-template'
export default {
  mixins: [BaseTable],
  components: {
    PageMain,
    PageHeader,
    RejectedForm,
    OrderImport,
    ChooseImportTemplate,
  },
  data() {
    return {
      usePage: true,
      rejectedFormOpts: { visible: false, hxPreOrderCode: '' },
      importOrderVisible: false,
      chooseTemplateOptions: { visible: false },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomHxPreOrderListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-hxBiz-preOrder-detail',
        params: { pageType, ...params },
        query,
      })
    },
    reject({ hxPreOrderCode }) {
      this.rejectedFormOpts = { hxPreOrderCode, visible: true }
    },
    importTemplate() {
      console.log('importTemplate')
      this.chooseTemplateOptions = {
        visible: true,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .drop {
    .el-button {
      border: 1px solid #28a745;
      color: #28a745;
      font-size: 0.875rem;
      border-radius: 3px 0px 0px 3px !important;
    }
    .el-dropdown__caret-button {
      border-left: none;
      border-radius: 0px 3px 3px 0px !important;
    }
    .el-button:hover {
      color: #fff;
      background-color: #28a745;
      border-color: #28a745;
    }
    .el-button--default::before {
      background: #d0d2d6;
    }
    .el-button--small {
      padding: 0.25rem 0.5rem;
      font-size: 0.875rem;
      line-height: 1.5;
    }
  }
}
</style>
